export const APP = 'app';

export const APP_ACTION_TYPES = {
  RECEIVE_ERROR: `${APP}/RECEIVE_ERROR`,

  SET_ACTIVE_TAB: `${APP}/SET_ACTIVE_TAB`,
  RECEIVE_ACTIVE_TAB: `${APP}/RECEIVE_ACTIVE_TAB`,

  FETCH_INITIAL_DATA: `${APP}/FETCH_INITIAL_DATA`,
  RECEIVE_INITIAL_DATA: `${APP}/RECEIVE_INITIAL_DATA`,

  RECEIVE_APP_LIFECYCLE_STATE: `${APP}/APP_LIFECYCLE_STATE`
};

export const APP_LIFECYCLE_STATE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  BACKGROUND: 'background'
};



// WEBPACK FOOTER //
// ./src/redux/app/constants.js